import { ObjectMeta } from "../../common";
import { DesignTokenTypedData, ThemeOriginObject, ThemeOriginSource, ThemeOverrideOrigin, ThemeOverrideOriginPart, } from "../elements";
import { z } from "zod";
//
// Overrides
//
export const ThemeOverrideImportModelBase = DesignTokenTypedData.and(z.object({
    id: z.string(),
    meta: ObjectMeta,
}));
export const ThemeOverrideImportModel = ThemeOverrideImportModelBase.and(z.object({
    origin: ThemeOverrideOrigin,
    collectionId: z.string().optional(),
}));
export const ThemeOverrideImportModelInput = ThemeOverrideImportModelBase.and(z.object({
    originId: z.string(),
    originMetadata: ThemeOverrideOriginPart,
    collectionId: z.string().optional(),
}));
//
// Themes
//
export const ThemeImportModel = z.object({
    id: z.string(),
    parentId: z.string().optional(),
    meta: ObjectMeta,
    brandPersistentId: z.string(),
    originSource: ThemeOriginSource,
    overrides: z.array(ThemeOverrideImportModel),
    sortOrder: z.number(),
    collectionIds: z.array(z.string()).optional(),
});
export const ThemeImportModelInput = z.object({
    id: z.string(),
    parentId: z.string().optional(),
    meta: ObjectMeta,
    originObjects: z.array(ThemeOriginObject),
    overrides: z.array(ThemeOverrideImportModelInput),
    collectionIds: z.array(z.string()).optional(),
});
//
// Theme Update
//
export const ThemeUpdateImportModel = z.object({
    themePersistentId: z.string(),
    overrides: z.array(ThemeOverrideImportModel),
});
export const ThemeUpdateImportModelInput = z.object({
    themePersistentId: z.string(),
    overrides: z.array(ThemeOverrideImportModelInput),
});
